// 要全局的变量的话
var global = {

}

//token问题，需要跳转登录页
global.axiosErr = function(that, res) {
	clearTimeout(that.axiosErrTime);
	that.axiosErrTime = setTimeout(() => {
		that.$message.error(res.data.message);
		if (res.data.code == 50003 || res.data.code == 40004 || res.data.code == 48001) {
			//清除全局登录信息、缓存
			that.$store.commit('logout');
			that.$router.push({
				path: '/logIn'
			})
		}
	}, 300)
}
// 定义方法
global.getTime = function(date, all, MD, hm, MDWhm, rWeek, DMD, h, m, M) {
	date = new Date(date * 1000); //如果date为13位不需要乘1000
	var Y = date.getFullYear();
	var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
	var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
	var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
	var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
	var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
	var week = date.getDay();
	var str = '';
	if (week == 0) {
		str = "周日";
	} else if (week == 1) {
		str = "周一";
	} else if (week == 2) {
		str = "周二";
	} else if (week == 3) {
		str = "周三";
	} else if (week == 4) {
		str = "周四";
	} else if (week == 5) {
		str = "周五";
	} else if (week == 6) {
		str = "周六";
	}

	if (all) {
		var nul = date + week + Y + M + D + h + m + s;
		return nul;
	} else if (MD) {
		return M + '月' + D + '日'
	} else if (hm) {
		return h + ':' + m
	} else if (MDWhm) {
		return M + '月' + D + '日' + '(' + str + ') ' + h + ':' + m
	} else if (rWeek) {
		return str
	} else if (DMD) {
		var todayDate = new Date();
		var tdMonth = todayDate.getMonth() + 1;
		var tdDate = todayDate.getDate();
		var textDay = '';
		M = Number(M);
		D = Number(D);
		if (tdMonth == M && tdDate == D) {
			textDay = '今天'
		} else if (tdMonth == M && tdDate + 1 == D) {
			textDay = '明天'
		} else if (tdMonth == M && tdDate + 2 == D) {
			textDay = '后天'
		} else {
			textDay = str;
		}
		return textDay + ' ' + M + '月' + D + '日';
	}
	// else if(h){
	// 	return Number(h)
	// }
	// else if(m){
	// 	return Number(m)
	// }
	// else if(M){
	// 	return Number(M);
	// }
	// else if(D){
	// 	return Number(D);
	// }
	return Y + '-' + M + '-' + D
};


//判断 昨天今天明天后天
global.getIsToday = function(val) {
	var td = new Date();
	td = new Date(td.getFullYear(), td.getMonth(), td.getDate());
	var od = new Date(val);
	od = new Date(od.getFullYear(), od.getMonth(), od.getDate());
	var xc = (od - td) / 1000 / 60 / 60 / 24;
	if (xc < 0) {
		return "昨天";
	} else if (xc == 0) {
		return "今天";
	} else if (xc < 2) {
		return "明天";
	} else if (xc < 3) {
		return "后天";
	}
}

//获取当天0点
global.getDayBegin = function(timeStamp) {
	var date = new Date(timeStamp * 1000);
	date.setHours(0);
	date.setMinutes(0);
	date.setSeconds(0);
	var comp_timeStamp = Math.round(date.getTime() / 1000);
	return comp_timeStamp;
}

global.getWeekDay = function(date) {
	var date = new Date(date * 1000);
	var week = date.getDay();
	var str = '';
	if (week == 0) {
		str = "星期天";
	} else if (week == 1) {
		str = "星期一";
	} else if (week == 2) {
		str = "星期二";
	} else if (week == 3) {
		str = "星期三";
	} else if (week == 4) {
		str = "星期四";
	} else if (week == 5) {
		str = "星期五";
	} else if (week == 6) {
		str = "星期六";
	}
	return str;
}

global.getIosYstDate = function(date, getMonth, getDate, getTextMD, getDay) {
	var date = new Date(date * 1000);
	date.setDate(date.getDate() - 1);
	if (getMonth) {
		var iosMonth = Number(date.getMonth() + 1);
		return iosMonth;
	} else if (getDate) {
		var iosDate = Number(date.getDate());
		return iosDate;
	} else if (getTextMD) {
		var iosMonth = date.getMonth() + 1;
		var iosDate = date.getDate();
		return iosMonth + '月' + iosDate + '日';
	} else if (getDay) {
		var week = date.getDay();
		var str = '';
		if (week == 0) {
			str = "星期天";
		} else if (week == 1) {
			str = "星期一";
		} else if (week == 2) {
			str = "星期二";
		} else if (week == 3) {
			str = "星期三";
		} else if (week == 4) {
			str = "星期四";
		} else if (week == 5) {
			str = "星期五";
		} else if (week == 6) {
			str = "星期六";
		}
		return str;
	}
}

//获取当天0点
global.getDayBegin = function(timeStamp){
  var date = new Date(timeStamp * 1000);
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  var comp_timeStamp = Math.round(date.getTime()/1000);
  return comp_timeStamp;
}

global.getMinAreaPrice = function (resPrice, areaPriceArrStr) {
  /*---如果后端返回的price不是>0,价格就取areaPriceArrStr中最低的价格---*/
  var price = resPrice;
  var isAreaPrice = false; //true：价格显示‘起’，false不显示
  if ((!resPrice || resPrice==0) && areaPriceArrStr && areaPriceArrStr.indexOf(';') >= 0) {
    isAreaPrice = true;
    var areaPriceArr = areaPriceArrStr.split(';')
    price = Math.min.apply(Math, areaPriceArr.map(item => {
      return item.split('price:')[1].split(',')[0]
    }));
    // 钱单位，’分‘转成’元‘
    price = (price / 100).toFixed(2);
  }
  else{
	  price = Number(resPrice).toFixed(2);
  }
  
  return {price,isAreaPrice};
}

global.transCountDown = function (timeStamp) {
  var curTimeStamp = Math.round(new Date().getTime() / 1000);
  var m = 0;
  var s = 0;
  var remainStamp = timeStamp - curTimeStamp;
  //还有剩倒计时
  if (remainStamp > 0) {
    m = Math.ceil(remainStamp / 60);
    s = Math.ceil(remainStamp % 60);
  }
  return {
    m,
    s
  }
}

export default global
